import * as yup from "yup";

export type RecipientType = "All" | "Dept" | "Ind";

export type AwardType = "Award" | "Certificate";

export type ValidityType = "Monthly" | "Quarterly" | "Yearly";

export type AwardStatus = "Draft" | "Published";

export const validityOption = [
    { lable: "Monthly" },
    { lable: "Quarterly" },
    { lable: "Half Yearly" },
    { lable: "Yearly" },
];

export interface Employee {
    employeeId: number;
    employee_Name: string;
}

export interface Props {
    isOpen: boolean;
    onClose: () => void;
    refresh: () => void;
    editData?: AwardListItem | null;

    onUpdate?: (data: any) => Promise<void>;
}

export const initialValues = {
    title: "",
    type: "Award",
    category: 0,
    validity: "Monthly",
    description: "",
    company: 0,
    branch: 0,
    issuedDate: "",
    department: 0,
    employeeId: 0,
}


export interface CreateAwardModel {
    title: string;
    type: string;
    category: number;
    validity: string;
    description: string;
    template?: File | null;
    recipients?: number;
    company: number;
    branch: number;
    department: number;
    // employeeId: number;
    employeeId: number | { employeeId: number; employee_Name: string } | null;
    employeeName: string;
    issuedDate: string;
}

export interface AwardListItem {
    awardId: number;
    title: string;
    type: string;
    status: AwardStatus;
    validityType: string;
    category: string;
    categoryId: number;
    description: string;
    companyId: number;
    branchId: number;
    departmentId: number;
    employeeId: number;
    recipients: string;
    createdAt: string;
    company?: number;
    branch?: number;
    department?: number;
    employeeName?: string;
    issuedDate: string;
    employeeObject: { employeeId: number; employee_Name: string };
}

// export const schema = yup.object({
//   employeeObject: yup
//     .object({
//       employeeId: yup.number().required("Employee name required"),
//       employee_Name: yup.string().required("Employee name required"),
//     })
//     .required("Employee name required"),
// });

export const createAwardSchema = (isEdit: boolean) =>
    yup.object({
        title: yup.string().required("Title is required"),
        type: yup.string().required("Type is required"),
        category: yup
            .number()
            .typeError("Category is required")
            .min(1, "Category is required")
            .required("Category is required"),

        validity: yup.string().required("Validity is required"),
        description: yup.string().required("Description is required"),
        issuedDate: yup
            .date()
            .typeError("Issued Date is required")
            .required("Issued Date is required"),

        company: yup
            .number()
            .typeError("Company is required")
            .min(1, "Company is required")
            .required("Company is required"),

        branch: yup
            .number()
            .typeError("Branch is required")
            .min(1, "Branch is required")
            .required("Branch is required"),

        department: yup
            .number()
            .typeError("Department is required")
            .min(1, "Department is required")
            .required("Department is required"),

        employeeId: isEdit
            ? yup.mixed().nullable()
            : yup
                .mixed()
                .required("Employee is required")
                .test("employee-validation", "Employee is required", function (value) {
                    if (!value) return false;
                    if (typeof value === "object") {
                        return (value as any)?.employeeId > 0;
                    }
                    if (typeof value === "number") {
                        return value > 0;
                    }
                    return false;
                }),

        template: yup
            .mixed<File>()
            .nullable()
            .test("fileType", "Only PDF files are allowed", (value) => {
                if (!value) return true;
                return value.type === "application/pdf";
            })
            .test("fileSize", "File size must be less than 5MB", (value) => {
                if (!value) return true;
                return value.size <= 5 * 1024 * 1024;
            }),
    });
